module.exports = __webpack_public_path__ + "static/media/wellen.833751b3.svg";